import Image from "next/image";
import check from "../../assets/images/upsc/check.png";
import styles from "./upsc-ias-ips-admission.module.css";
import handpointer from "../../assets/images/hand.svg";
import { FaChalkboardTeacher, FaUserTie, FaBookOpen, FaAward, FaUserGraduate } from "react-icons/fa";
import Link from "next/link";

const Program_Features = () => {
return(
    <>
    <section className={styles.featureSection}>
    <div className="container">
        <div className="row g-5">

        {/* Program Features */}
        <div data-aos="fade-down" className="col-lg-6">
            <div className={styles.featureCard1}>
            <h2 className={styles.featureTitle}>Program Features</h2>

            <div className={styles.item}>
                <FaChalkboardTeacher className={styles.icon}/>
                <span>900+ Hours Structured Classroom Teaching</span>
            </div>

            <div className={styles.item}>
                <FaUserTie className={styles.icon}/>
                <span>100+ Hours Dedicated Personal Mentoring</span>
            </div>

            <div className={styles.item}>
                <FaBookOpen className={styles.icon}/>
                <span>Extensive Prelims & Mains Test Series</span>
            </div>

            <div className={styles.item}>
                <FaAward className={styles.icon}/>
                <span>Comprehensive Interview Guidance</span>
            </div>

            <div className={styles.item}>
                <FaUserGraduate className={styles.icon}/>
                <span>Complete Study & Reference Materials</span>
            </div>

            </div>
        </div>

        {/* Key Differentiators */}
        <div data-aos="fade-up" className="col-lg-6">
            <div className={styles.featureCard1}>
            <h2 className={styles.featureTitle}>Key Differentiators</h2>

            <div className={styles.item}>
                <FaAward className={styles.icon}/>
                <span>Consistently Producing Toppers Since 2004</span>
            </div>

            <div className={styles.item}>
                <FaChalkboardTeacher className={styles.icon}/>
                <span>10+ Years Experienced Faculty Team</span>
            </div>

            <div className={styles.item}>
                <FaUserGraduate className={styles.icon}/>
                <span>Guidance From Achievers</span>
            </div>

            <div className={styles.item}>
                <FaUserTie className={styles.icon}/>
                <span>Interaction With Serving Bureaucrats</span>
            </div>

            <div className={styles.item}>
                <FaBookOpen className={styles.icon}/>
                <span>Scientific & Personalised Mentoring</span>
            </div>

            </div>
        </div>

        </div>
    </div>
    </section>



    </>
    )
}
export default Program_Features;